import { Controller } from "@hotwired/stimulus"

export default class RowSelectorController extends Controller {
  static targets = ["rowButton", "selectAllButton", "form", "action", "counter"]
  static values = {
    attributeName: String,
  }

  toggleSelectAll(event) {
    const checkbox = event.target
    const isChecked = checkbox.checked

    this.rowButtonTargets.forEach((rowButton) => {
      const rowCheckbox = rowButton.querySelector('input[type="checkbox"]')
      if (rowCheckbox) {
        rowCheckbox.checked = isChecked
      }
    })

    this.#toggleActionButtons(isChecked)
    this.updateCounters()
  }

  toggleRowSelection(_event) {
    // Check if any row is selected
    const anySelected = this.rowButtonTargets.some((button) => {
      const cb = button.querySelector('input[type="checkbox"]')
      return cb && cb.checked
    })

    this.#toggleActionButtons(anySelected)

    // Update select all checkbox state
    const selectAllCheckbox = this.selectAllButtonTarget.querySelector(
      'input[type="checkbox"]'
    )
    if (selectAllCheckbox) {
      const allSelected = this.rowButtonTargets.every((button) => {
        const cb = button.querySelector('input[type="checkbox"]')
        return cb && cb.checked
      })
      selectAllCheckbox.checked = allSelected
    }

    this.updateCounters()
  }

  submitForm() {
    const selectedRows = this.rowButtonTargets.filter((row) => {
      const checkbox = row.querySelector('input[type="checkbox"]')
      return checkbox && checkbox.checked
    })

    selectedRows.forEach((row) => {
      const hiddenInput = document.createElement("input")
      hiddenInput.type = "hidden"
      hiddenInput.name = `${this.attributeNameValue}[]`
      hiddenInput.value = row.dataset.rowValueId
      this.formTarget.appendChild(hiddenInput)
    })

    this.formTarget.requestSubmit()

    const hiddenInputs = this.formTarget.querySelectorAll(
      `input[type="hidden"][name="${this.attributeNameValue}[]"]`
    )

    hiddenInputs.forEach((input) => {
      input.parentNode.removeChild(input)
    })
  }

  updateCounters() {
    this.counterTargets.forEach((counter) => {
      const selectedRowsCount = this.rowButtonTargets.filter((row) => {
        const checkbox = row.querySelector('input[type="checkbox"]')
        return checkbox && checkbox.checked
      }).length

      counter.textContent = selectedRowsCount
    })
  }

  #toggleActionButtons(shouldEnable) {
    this.actionTargets.forEach((action) => {
      if (shouldEnable) {
        action.removeAttribute("disabled")
      } else {
        action.setAttribute("disabled", "disabled")
      }
    })
  }
}
